<script setup lang="ts">
import { classMerge } from '../utils'
import { useCarousel } from './use-carousel'

import type { CarouselProps, WithClassAsProps } from './carousel-interface'

const props = defineProps<CarouselProps & WithClassAsProps>()

const { canScrollPrev } = useCarousel()
</script>

<template>
  <div :class="classMerge(
    'hidden items-center absolute top-0 left-0 w-24 h-full bg-gradient-to-l from-transparent via-gradientstop via-40% to-gradientstop md:block',
    !props.showWhenCannotScroll && !canScrollPrev ? 'md:hidden' : '',
    props.class
  )">
    <slot />
  </div>
</template>
